import React from 'react'
import { List, ListItemButton, ListItemText } from '@mui/material'
import { useGlobalState } from 'state'
import hinanAreaJson from 'assets/hinan/hinanArea.json'
import { blue, grey, red } from '@mui/material/colors'
import { getPolygonCenter } from 'common/utils'

type School = {
  name: string
  risk: boolean
}

export const HinanListControl = () => {
  const { app, mapbox } = useGlobalState()
  const [selectedIndex, setSelectedIndex] = React.useState(-1)
  const [schools, setSchools] = React.useState<School[]>([])

  React.useEffect(() => {
    fetchSchools()
  }, [])

  React.useEffect(() => {
    fetchSchools()
  }, [app.hinanData])

  const select = (index: number) => {
    if (!mapbox) return
    setSelectedIndex(index)
    const target = schools[index]
    const feature = hinanAreaJson.features.find((feature: any) => feature.properties.NAME === target.name)
    if (!feature) return
    const coordinates = feature.geometry.type === 'MultiPolygon' ? feature.geometry.coordinates[0] : feature.geometry.coordinates
    const center = getPolygonCenter(coordinates as GeoJSON.Position[][])
    mapbox.flyTo({center: center, zoom: 13})
  }

  const fetchSchools = async () => {
    const targetNames = Object.keys(app.hinanData)
    setSchools(hinanAreaJson.features.map((feature: any) => {
      return {
        name: feature.properties.NAME,
        risk: targetNames.includes(feature.properties.NAME)
      }
    }))
  }

  return (
    <List component="nav" dense disablePadding sx={{minWidth: 110}}>
      { schools.map((school, index) => (
        <ListItemButton
          selected={selectedIndex === index}
          onClick={() => select(index)}
          key={index}
          sx={{
            borderBottom: '1px solid #eee',
            pl: 1,
            py: '2px',
            color: grey[800],
            '&.Mui-selected': {
              backgroundColor: blue[50],
              color: grey[900],
              '&:hover': {
                backgroundColor: blue[100],
              }
            }
          }}
        >
          <ListItemText
            primaryTypographyProps={{fontSize: 13}}
            primary={school.name}
            sx={{
              borderLeftWidth: '5px',
              borderLeftStyle: 'solid',
              borderLeftColor: school.risk ? red[500]: grey[300],
              pl: 1,
            }} />
        </ListItemButton>
      ))}
    </List>
  )
}
